import { render, staticRenderFns } from "./SetupStart.vue?vue&type=template&id=376fd2cf&scoped=true&"
import script from "./SetupStart.vue?vue&type=script&lang=js&"
export * from "./SetupStart.vue?vue&type=script&lang=js&"
import style0 from "./SetupStart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SetupStart.vue?vue&type=style&index=1&id=376fd2cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fd2cf",
  null
  
)

export default component.exports